import {
  CurrencyRates,
  InvoiceDisplayData,
  PaginationRequest,
  PaginationResult,
  PaymentProvider,
  PurchaseMetrics,
  PurchaseStatusResponse,
  PurchaseType,
} from '@monorepo/types';
import CrudService from '../core/crud-service';

export default class PurchaseService extends CrudService {
  static override route = 'purchase';

  async getPurchases(
    paginateRequest: PaginationRequest,
  ): Promise<PaginationResult<PurchaseType>> {
    try {
      const response: { data: PaginationResult<PurchaseType> } =
        await this.httpService.get(this.path, {
          params: paginateRequest,
        });
      return response.data;
    } catch (e) {
      console.error(`Failed getting purchases`, e);
      throw e;
    }
  }

  async getCurrencies(): Promise<CurrencyRates> {
    try {
      const response: { data: CurrencyRates } = await this.httpService.get(
        `${this.path}/currencies`,
      );
      return response.data;
    } catch (e) {
      console.error(`Failed getting currencies`, e);
      return {} as CurrencyRates;
    }
  }

  async getPaymentProviders(currency?: string): Promise<PaymentProvider[]> {
    try {
      const response: { data: PaymentProvider[] } = await this.httpService.get(
        `${this.path}/payment-providers`,
        {
          params: { currency },
        },
      );

      return response.data;
    } catch (e) {
      console.error(`Failed getting payment providers`, e);
      return [];
    }
  }

  async getPurchaseInvoice(purchaseId: string): Promise<InvoiceDisplayData> {
    try {
      const response: { data: InvoiceDisplayData } = await this.httpService.get(
        `${this.path}/invoice/${purchaseId}`,
      );
      return response.data;
    } catch (e) {
      console.error(`Failed getting purchase invoice: ${purchaseId}`, e);
      throw e;
    }
  }

  async getPurchaseStatus(snapshotId: string): Promise<PurchaseStatusResponse> {
    try {
      const response: { data: PurchaseStatusResponse } =
        await this.httpService.get(`${this.path}/status/${snapshotId}`);
      return response.data;
    } catch (e) {
      console.error(
        `Failed getting purchase status with snapshot id: ${snapshotId}`,
        e,
      );
      throw e;
    }
  }

  async getPurchaseMetrics(): Promise<PurchaseMetrics> {
    try {
      const response: { data: PurchaseMetrics } = await this.httpService.get(
        `${this.path}/metrics`,
      );
      return response.data;
    } catch (e) {
      console.error(`Failed getting purchase metrics`, e);
      throw e;
    }
  }
}
